import Swiper from "swiper";
import { Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs, EffectFade, Autoplay, EffectCoverflow } from "swiper/modules";

/**
 * @param swiperInit
 */
export default function swiperInit() {
	const swiperHome = new Swiper(".section-home-banner .swiper", {
		loop: true,
		slidesPerView: 1,
		speed: 1200,
		spaceBetween: 0,
		autoplay: {
			delay: 4500,
		},
		modules: [Pagination, EffectFade, Autoplay, Navigation],
		pagination: {
			el: ".section-home-banner .swiper-pagination",
			clickable: true,
		},
		navigation: {
			prevEl: ".section-home-banner .btn-prev",
			nextEl: ".section-home-banner .btn-next",
		},
	});
	new Swiper(".section-home-coursers .swiper", {
		loop: true,
		slidesPerView: 1,
		loopAdditionalSlides: 4,
		speed: 500,
		spaceBetween: 0,
		autoplay: {
			delay: 4500,
		},
		freeMode: false,
		effect: "creative",
		creativeEffect: {
			limitProgress: 2,
			prev: {
				translate: [0, 0, -10],
				rotate: [0, 0, 0],
				opacity: 0.1,
			},
			next: {
				translate: [0, "-40px", -62],
				rotate: [0, 0, 0],
				opacity: 1,
			},
		},
		modules: [Pagination, EffectCreative, Autoplay, Navigation],
	});
	new Swiper(".section-home-about .swiper", {
		loop: true,
		slidesPerView: "auto",
		speed: 500,
		spaceBetween: 15,
		autoplay: {
			delay: 4500,
		},
		modules: [Pagination, Autoplay, Navigation],
	});
	new Swiper(".slide-image-2 .swiper", {
		loop: true,
		slidesPerView: 1,
		speed: 500,
		spaceBetween: 15,
		navigation: {
			prevEl: ".slide-image-2 .btn-prev",
			nextEl: ".slide-image-2 .btn-next",
		},
		pagination: {
			el: ".slide-image-2 .swiper-pagination",
			clickable: true,
		},
		autoplay: {
			delay: 4500,
		},
		breakpoints: {
			1024: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
		},
		modules: [Pagination, Autoplay, Navigation],
	});
	new Swiper(".slide-image-logo .swiper", {
		loop: true,
		speed: 500,
		slidesPerGroup: 2,
		slidesPerView: 2,
		observeParents: true,
		observer: true,
		spaceBetween: 15,
		navigation: {
			prevEl: ".slide-image-logo .btn-prev",
			nextEl: ".slide-image-logo .btn-next",
		},
		autoplay: {
			delay: 4500,
		},
		breakpoints: {
			768: {
				slidesPerGroup: 3,
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1024: {
				slidesPerGroup: 4,
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1200: {
				slidesPerGroup: 5,
				slidesPerView: 5,
				spaceBetween: 128,
			},
		},
		pagination: {
			el: ".slide-image-logo  .swiper-pagination",
			clickable: true,
		},
		modules: [Pagination, Autoplay, Navigation],
	});
}
